/**
 * AI表格边栏插件国际化文案
 */

export interface Locales {
  // App 通用
  title: string;
  loading: string;
  noData: string;
  success: string;
  error: string;

  // App 按钮和标题
  buttonText: string;
  guideText: string;
  selectedCount: string;
  deleteSelected: string;
  columnTitle: string;
  loadingTitle: string;

  // 数据表和视图
  selectSheet: string;
  unsupportedSheet: string;
  selectView: string;
  currentSheet: string;
  sheetName: string;
  fieldsCount: string;
  recordsCount: string;
  currentTable: string;
  totalSheets: string;
  sheetsUnit: string;
  fieldsUnit: string;
  recordsUnit: string;

  // 文档信息
  documentInfo: string;
  documentUuid: string;
  sheetManagement: string;
  fieldManagement: string;
  recordManagement: string;
  sheetManagementDescription: string;
  fieldManagementDescription: string;
  recordManagementDescription: string;

  // 数据表操作
  createSheet: string;
  deleteSheet: string;
  refreshSheets: string;
  enterSheetName: string;
  createSheetSuccess: string;
  deleteSheetSuccess: string;
  pleaseSelectSheet: string;
  cannotDeleteLastSheet: string;

  // 字段操作
  addField: string;
  viewFields: string;
  fieldName: string;
  fieldType: string;
  addFieldSuccess: string;
  enterFieldName: string;
  selectFieldType: string;
  cannotDeletePrimaryField: string;
  cannotDeletePrimaryKeyField: string;
  confirmDeleteField: string;
  deleteFieldSuccess: string;
  deleteFieldFailed: string;
  dataWillBeLost: string;
  primaryKey: string;

  // 记录操作
  addRecord: string;
  viewRecords: string;
  recordTitle: string;
  recordId: string;
  status: string;
  createTime: string;
  addRecordSuccess: string;
  updateRecordSuccess: string;
  deleteRecordSuccess: string;
  enterRecordTitle: string;
  selectStatus: string;
  operation: string;
  edit: string;
  delete: string;
  save: string;
  cancel: string;
  confirmDelete: string;
  operationFailed: string;

  // 字段类型
  text: string;
  number: string;
  date: string;
  singleSelect: string;
  multiSelect: string;
  attachment: string;
  link: string;
  currency: string;

  // 状态
  pending: string;
  inProgress: string;
  completed: string;
  cancelled: string;
  untitled: string;
}

export const locales: Record<string, Locales> = {
  "zh-CN": {
    // App 通用
    title: "AI表格工具箱",
    loading: "加载中...",
    noData: "暂无数据",
    success: "成功",
    error: "错误",

    // App 按钮和标题
    buttonText: "拆分全部",
    guideText: "点击表格单元格添加到列表，再次点击移除",
    selectedCount: "已选中",
    deleteSelected: "删除所选",
    columnTitle: "邮件原始标题",
    loadingTitle: "加载中...",

    // 数据表和视图
    selectSheet: "选择数据表",
    unsupportedSheet: '当前数据表不是"询价预处理表"，无法使用此插件',
    selectView: "选择视图",
    currentSheet: "当前数据表",
    sheetName: "数据表名称",
    fieldsCount: "字段数量",
    recordsCount: "记录数量",
    currentTable: "当前表",
    totalSheets: "数据表总数",
    sheetsUnit: "张表",
    fieldsUnit: "个字段",
    recordsUnit: "条记录",

    // 文档信息
    documentInfo: "文档信息",
    documentUuid: "文档UUID",
    sheetManagement: "数据表管理",
    fieldManagement: "字段管理",
    recordManagement: "记录管理",
    sheetManagementDescription: "数据表管理",
    fieldManagementDescription: "字段管理",
    recordManagementDescription: "记录管理",

    // 数据表操作
    createSheet: "创建数据表",
    deleteSheet: "删除数据表",
    refreshSheets: "刷新列表",
    enterSheetName: "请输入数据表名称",
    createSheetSuccess: "数据表创建成功",
    deleteSheetSuccess: "数据表删除成功",
    pleaseSelectSheet: "请选择数据表",
    cannotDeleteLastSheet: "不能删除最后一张数据表",

    // 字段操作
    addField: "添加字段",
    viewFields: "查看字段",
    fieldName: "字段名称",
    fieldType: "字段类型",
    addFieldSuccess: "字段添加成功",
    enterFieldName: "请输入字段名称",
    selectFieldType: "请选择字段类型",
    cannotDeletePrimaryField: "不能删除主键字段",
    cannotDeletePrimaryKeyField: "不能删除主键字段",
    confirmDeleteField: "确定要删除字段",
    deleteFieldSuccess: "删除字段成功",
    deleteFieldFailed: "删除字段失败",
    dataWillBeLost: "删除后该字段的所有数据将丢失",
    primaryKey: "主键",

    // 记录操作
    addRecord: "添加记录",
    viewRecords: "查看记录",
    recordTitle: "记录标题",
    recordId: "记录ID",
    status: "状态",
    createTime: "创建时间",
    addRecordSuccess: "记录添加成功",
    updateRecordSuccess: "记录更新成功",
    deleteRecordSuccess: "记录删除成功",
    enterRecordTitle: "请输入记录标题",
    selectStatus: "请选择状态",
    operation: "操作",
    edit: "编辑",
    delete: "删除",
    save: "保存",
    cancel: "取消",
    confirmDelete: "确认删除",
    operationFailed: "操作失败",

    // 字段类型
    text: "文本",
    number: "数字",
    date: "日期",
    singleSelect: "单选",
    multiSelect: "多选",
    attachment: "附件",
    link: "链接",
    currency: "货币",

    // 状态
    pending: "待处理",
    inProgress: "进行中",
    completed: "已完成",
    cancelled: "已取消",
    untitled: "无标题",
  },
  "en-US": {
    // App 通用
    title: "Multi-table Management Assistant",
    loading: "Loading...",
    noData: "No Data",
    success: "Success",
    error: "Error",

    // App 按钮和标题
    buttonText: "Split all",
    guideText: "Click cell to add, click again to remove",
    selectedCount: "Selected",
    deleteSelected: "Delete selected",
    columnTitle: "Email Title",
    loadingTitle: "Loading...",

    // 数据表和视图
    selectSheet: "Select Sheet",
    unsupportedSheet:
      'Current sheet is not "询价预处理表", cannot use this plugin',
    selectView: "Select View",
    currentSheet: "Current Sheet",
    sheetName: "Sheet Name",
    fieldsCount: "Fields Count",
    recordsCount: "Records Count",
    currentTable: "Current Table",
    totalSheets: "Total Sheets",
    sheetsUnit: "sheets",
    fieldsUnit: "fields",
    recordsUnit: "records",

    // 文档信息
    documentInfo: "Document Info",
    documentUuid: "Document UUID",
    sheetManagement: "Sheet Management",
    fieldManagement: "Field Management",
    recordManagement: "Record Management",
    sheetManagementDescription: "Sheet Management",
    fieldManagementDescription: "Field Management",
    recordManagementDescription: "Record Management",

    // 数据表操作
    createSheet: "Create Sheet",
    deleteSheet: "Delete Sheet",
    refreshSheets: "Refresh List",
    enterSheetName: "Enter sheet name",
    createSheetSuccess: "Sheet created successfully",
    deleteSheetSuccess: "Sheet deleted successfully",
    pleaseSelectSheet: "Please select a sheet",
    cannotDeleteLastSheet: "Cannot delete the last sheet",

    // 字段操作
    addField: "Add Field",
    viewFields: "View Fields",
    fieldName: "Field Name",
    fieldType: "Field Type",
    addFieldSuccess: "Field added successfully",
    enterFieldName: "Enter field name",
    selectFieldType: "Select field type",
    cannotDeletePrimaryField: "Cannot delete primary field",
    cannotDeletePrimaryKeyField: "Cannot delete primary key field",
    confirmDeleteField: "Are you sure to delete field",
    deleteFieldSuccess: "Field deleted successfully",
    deleteFieldFailed: "Failed to delete field",
    dataWillBeLost: "All data in this field will be lost after deletion",
    primaryKey: "Primary Key",

    // 记录操作
    addRecord: "Add Record",
    viewRecords: "View Records",
    recordTitle: "Record Title",
    recordId: "Record ID",
    status: "Status",
    createTime: "Create Time",
    addRecordSuccess: "Record added successfully",
    updateRecordSuccess: "Record updated successfully",
    deleteRecordSuccess: "Record deleted successfully",
    enterRecordTitle: "Enter record title",
    selectStatus: "Select status",
    operation: "Operation",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    confirmDelete: "Confirm Delete",
    operationFailed: "Operation failed",

    // 字段类型
    text: "Text",
    number: "Number",
    date: "Date",
    singleSelect: "Single Select",
    multiSelect: "Multi Select",
    attachment: "Attachment",
    link: "Link",
    currency: "Currency",

    // 状态
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    untitled: "Untitled",
  },
  "ja-JP": {
    // App 通用
    title: "マルチテーブル管理アシスタント",
    loading: "読み込み中...",
    noData: "データなし",
    success: "成功",
    error: "エラー",

    // App 按钮和标题
    buttonText: "すべて分割",
    guideText: "セルをクリックで追加、もう一度クリックで削除",
    selectedCount: "選択済み",
    deleteSelected: "選択を削除",
    columnTitle: "メール件名",
    loadingTitle: "読み込み中...",

    // 数据表和视图
    selectSheet: "シートを選択",
    unsupportedSheet:
      '現在のシートは"询价预处理表"ではありません。此プラグインを使用できません。',
    selectView: "ビューを選択",
    currentSheet: "現在のシート",
    sheetName: "シート名",
    fieldsCount: "フィールド数",
    recordsCount: "レコード数",
    currentTable: "現在のテーブル",
    totalSheets: "シート総数",
    sheetsUnit: "シート",
    fieldsUnit: "フィールド",
    recordsUnit: "レコード",

    // 文档信息
    documentInfo: "ドキュメント情報",
    documentUuid: "ドキュメントUUID",
    sheetManagement: "シート管理",
    fieldManagement: "フィールド管理",
    recordManagement: "レコード管理",
    sheetManagementDescription: "シート管理",
    fieldManagementDescription: "フィールド管理",
    recordManagementDescription: "レコード管理",

    // 数据表操作
    createSheet: "シート作成",
    deleteSheet: "シート削除",
    refreshSheets: "リスト更新",
    enterSheetName: "シート名を入力してください",
    createSheetSuccess: "シートが正常に作成されました",
    deleteSheetSuccess: "シートが正常に削除されました",
    pleaseSelectSheet: "シートを選択してください",
    cannotDeleteLastSheet: "最後のシートは削除できません",

    // 字段操作
    addField: "フィールド追加",
    viewFields: "フィールド表示",
    fieldName: "フィールド名",
    fieldType: "フィールドタイプ",
    addFieldSuccess: "フィールドが正常に追加されました",
    enterFieldName: "フィールド名を入力してください",
    selectFieldType: "フィールドタイプを選択してください",
    cannotDeletePrimaryField: "プライマリフィールドは削除できません",
    cannotDeletePrimaryKeyField: "プライマリキーフィールドは削除できません",
    confirmDeleteField: "フィールドを削除してもよろしいですか",
    deleteFieldSuccess: "フィールドの削除に成功しました",
    deleteFieldFailed: "フィールドの削除に失敗しました",
    dataWillBeLost: "削除後、このフィールドのすべてのデータが失われます",
    primaryKey: "プライマリキー",

    // 记录操作
    addRecord: "レコード追加",
    viewRecords: "レコード表示",
    recordTitle: "レコードタイトル",
    recordId: "レコードID",
    status: "ステータス",
    createTime: "作成時間",
    addRecordSuccess: "レコードが正常に追加されました",
    updateRecordSuccess: "レコードが正常に更新されました",
    deleteRecordSuccess: "レコードが正常に削除されました",
    enterRecordTitle: "レコードタイトルを入力してください",
    selectStatus: "ステータスを選択してください",
    operation: "操作",
    edit: "編集",
    delete: "削除",
    save: "保存",
    cancel: "キャンセル",
    confirmDelete: "削除確認",
    operationFailed: "操作に失敗しました",

    // 字段类型
    text: "テキスト",
    number: "数値",
    date: "日付",
    singleSelect: "単一選択",
    multiSelect: "複数選択",
    attachment: "添付ファイル",
    link: "リンク",
    currency: "通貨",

    // 状态
    pending: "保留中",
    inProgress: "進行中",
    completed: "完了",
    cancelled: "キャンセル済み",
    untitled: "無題",
  },
};

export function getLocale(locale: string): Locales {
  return locales[locale] || locales["zh-CN"];
}
